<adaa-auth-layout>
    <form [formGroup]="verificationForm" (ngSubmit)="submit()">
        <div class="adaa-auth-subtitle">{{ "login.two_steps_title" | translate }}</div>
        <p class="adaa-auth-text">{{ "login.select_channel" | translate }}</p>

        <div class="adaa-auth-methods">
            <button
                type="button"
                class="adaa-auth-method"
                [class.active]="selectedMethod() === verificationMethod.EMAIL"
                (click)="selectMethod(verificationMethod.EMAIL)"
            >
                <i class="fa-solid fa-envelope"></i>
                <span>{{ "common.form.label.email" | translate }}</span>
            </button>
            <button
                type="button"
                class="adaa-auth-method"
                [class.active]="selectedMethod() === verificationMethod.SMS"
                (click)="selectMethod(verificationMethod.SMS)"
            >
                <i class="fa-solid fa-mobile-screen"></i>
                <span>{{ "login.text_message" | translate }} {{ getEncodeMobileNumber() }}</span>
            </button>
        </div>

        @if (lockCounter() === 0) {
            <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost mt-2 mb-4" (click)="sendVerificationCode()">
                {{ "common.form.button.send" | translate }}
            </button>
        } @else {
            <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost mt-2 mb-4 disabled-button">
                {{ "login.resendCode" | translate }} - {{ lockCounter() }}
            </button>
        }

        <div class="adaa-auth-field">
            <adaa-form-input
                [required]="true"
                [placeholder]="'login.confirmation_code' | translate"
                controlName="verificationCode"
                formControlName="verificationCode"
                inputType="positiveNumber"
                [maxLength]="999999"
                [invalid]="verificationForm.get('verificationCode')?.dirty && verificationForm.get('verificationCode')?.errors?.['required']"
            ></adaa-form-input>
        </div>

        <div class="adaa-auth-check">
            <adaa-form-checkbox [label]="'login.dont_ask' | translate" controlName="rememberMe" formControlName="rememberMe"></adaa-form-checkbox>
        </div>

        <button type="submit" class="adaa-auth-btn adaa-auth-btn-primary">{{ "login.confirm" | translate }}</button>
    </form>
</adaa-auth-layout>
